import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Header, Criterion } from '../index';
import Enums from 'utils/EnumsManager';

const getOptionsByType = (type, targetId, collection) => {
  if (type === Enums.FieldTypes.PickList) {
    const picklist = collection.find(element => element.id === targetId);
    if (picklist) {
      return picklist.picklists;
    }
  }
  return [];
};

// others includes fields, conditions, handleFieldChange, handleConditionChange, handleValueChange, handleFilterRemove, handleAddonClick
const Filters = ({
  filters,
  conditions,
  ...others,
}) => {
  const getConditons = filterId => {
    if (_.isArray(conditions)) return conditions;
    if (_.isObject(conditions) && filterId && _.isArray(conditions[filterId])) return conditions[filterId];
    return [];
  };
  return (
    <Fragment>
      <Header />
      {filters.map(filter => (
        <Criterion
          needSearchBar
          key={filter.displayNum}
          criterion={filter}
          conditions={getConditons(filter.fieldId)}
          {...filter}
          {...others}
        />
      ))}
    </Fragment>
  );
};

export default Filters;



// WEBPACK FOOTER //
// ./src/components/page/FilterCriteria/components/Filters/index.jsx